import React from "react";
import { Toast } from "react-bootstrap";

function CustomizedSnackbars({ message, severity, open, onClose }) {
  return (
    <div>
      <Toast
        show={open}
        onClose={onClose}
        delay={3000} // Auto hide duration
        autohide
        style={{ position: "absolute", top: 20, right: 20, zIndex: 9999 }}
      >
        <Toast.Body
          style={{
            backgroundColor:
              severity === "success"
                ? "#28a745"
                : severity === "error"
                ? "#dc3545"
                : "#ffc107",
            color: "white",
          }}
        >
          {message}
        </Toast.Body>
      </Toast>
    </div>
  );
}

export default CustomizedSnackbars;
